import { useState }     from 'react';
import { Container }    from '@material-ui/core';
import { connect }      from 'react-redux';
import { toast }        from 'react-toastify';
// Redux
import {changeView}     from '../../redux/actions/Menu';
import {updateApps}    from '../../redux/actions/Apps';
// Components
import Input        from '../global/Input';
import ButtonsForm  from '../global/ButtonsForm';
import DatePickers  from '../global/DatePickers';
// Values
import {StateView, systemValue, codeVersion, actionValue, toastText}  from '../../values';
// Styles
import {useStyles}  from '../../style';
// Api
import {updateData, postData, deleteData, postValidate, updateValidate}   from '../../utils/apps';

const Form = ({data, token, stateView, changeView, updateApps}) => {
    const classes = useStyles()
    const [blockData, setblockData] = useState(stateView===StateView.state2?"":"disabled")
    // State buttons ----------------------------------------------------------------
    const [edit, setEdit]           = useState(0)
    const [erase, setErase]         = useState(0)
    const [add, setAdd]             = useState(0)

    // Data -------------------------------------------------------------------------
    const [version, setVersion]     = useState(data.Version?data.Version:'AGENT')
    const [system, setSystem]       = useState(data.System?data.System:'ANDROID')
    const [action, setAction]       = useState(data.Action?data.Action:'NOTIFY')
    const [code, setCode]           = useState(data.Code?data.Code:'')
    const [release, setRelease]     = useState(data.Release?data.Release:new Date())

    // Functions --------------------------------------------------------------------
    const Back = () =>{
        changeView(StateView.state1)
        updateApps([])
    }

    const Edit = async() =>{
        const value = edit + 1
        setEdit(value)
        setblockData('')
        if(value===2){
            const validate = updateValidate(code)
            if(validate.flag){
                const res = await updateData(data.Id, token, version, system, action, code, release)
                if(res){
                    toast.success(toastText.update)
                    console.log(toastText.update)
                    changeView(StateView.state1)
                    updateApps([])
                } else{
                    toast.warn(toastText.warning)
                    console.log(toastText.warning)
                    setEdit(1)
                }
            } else{
                toast.warn(validate.message)
                console.log(validate.message)
                setEdit(1)
            }
        }
    }
    const Add = async() =>{
        const value = add + 1
        setAdd(value)
        if(value===1){
            const validate = postValidate(code)
            if(validate.flag){
                const res = await postData(token, version, system, action, code, release)
                if(res){
                    toast.success(toastText.add)
                    console.log(toastText.add)
                    changeView(StateView.state1)
                } else{
                    toast.warn(toastText.warning)
                    console.log(toastText.warning)
                    setAdd(0)
                }
            } else{
                toast.warn(validate.message)
                console.log(validate.message)
                setAdd(0)
            }
        }
    }
    const Delete = async() =>{
        const value = erase + 1
        setErase(value)
        if(value===1){
            const res = await deleteData(data.Id, token)
            if(res){
                toast.success(toastText.delete)
                console.log(toastText.delete)
                changeView(StateView.state1)
                updateApps([])
            } else{
                toast.warn(toastText.warning)
                console.log(toastText.warning)
                setErase(0)
            }
        }
    }
    return (
        <Container maxWidth="xl">
            <div style={{background:'#fff', paddingBottom:50, paddingTop:20}}>
                <Container maxWidth="xl">
                    <div style={{display:'flex'}}>
                        <div style={{width:'48%'}}>
                            <div style={{display:'flex', alignContent:'center'}}>
                                <p className={classes.title_input}>{'Sistema'}</p>
                                <select style={{cursor:blockData === 'disabled' ? '' : 'pointer'}}
                                    defaultValue={system} 
                                    className={classes.select} 
                                    onChange={e => setSystem(e.target.value)}
                                    disabled={blockData}>
                                        <option value={systemValue.ANDROID}>{systemValue.text1}</option>
                                        <option value={systemValue.IOS}>{systemValue.text2}</option>
                                </select>
                            </div>
                            <div style={{display:'flex', alignContent:'center'}}>
                                <p className={classes.title_input}>{'Versión'}</p>
                                <select style={{cursor:blockData === 'disabled' ? '' : 'pointer'}}
                                    defaultValue={version} 
                                    className={classes.select} 
                                    onChange={e => setVersion(e.target.value)}
                                    disabled={blockData}>
                                        <option value={codeVersion.AGENT}>{codeVersion.text1}</option>
                                        <option value={codeVersion.USER}>{codeVersion.text2}</option>
                                </select>
                            </div>
                            <Input title={'Código'} value={code} setData={setCode} blockData={blockData} />
                        </div>
                        <div style={{width:'4%'}} />
                        <div style={{width:'48%'}}>
                            <DatePickers date={release} setDate={setRelease} disabled={blockData} />
                            <div style={{display:'flex', alignContent:'center'}}>
                                <p className={classes.title_input}>{'Acción'}</p>
                                <select style={{cursor:blockData === 'disabled' ? '' : 'pointer'}}
                                    defaultValue={action} 
                                    className={classes.select} 
                                    onChange={e => setAction(e.target.value)}
                                    disabled={blockData}>
                                        <option  value={actionValue.NOTIFY}>{actionValue.text1}</option>
                                        <option  value={actionValue.FORCE}>{actionValue.text2}</option>
                                        <option  value={actionValue.OPEN}>{actionValue.text3}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            <ButtonsForm View={stateView} Back={Back} Edit={Edit} edit={edit} Add={Add} add={add} Delete={Delete} erase={erase} />
        </Container>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    data:           state.Apps.appsEdit,
    token:          state.Panel.token,
})

export default connect(mapStateToProps, {changeView, updateApps})(Form);
